/**
 * Password rules aligned with the Cognito user pool policy and API validation
 * (`POST /auth/signup-cognito` requires min length 12).
 */
export const PASSWORD_RULES = [
  {
    id: 'length',
    label: 'At least 12 characters',
    test: (pw) => String(pw || '').length >= 12,
  },
  {
    id: 'upper',
    label: 'At least one uppercase letter (A–Z)',
    test: (pw) => /[A-Z]/.test(pw),
  },
  {
    id: 'lower',
    label: 'At least one lowercase letter (a–z)',
    test: (pw) => /[a-z]/.test(pw),
  },
  {
    id: 'number',
    label: 'At least one number (0–9)',
    test: (pw) => /[0-9]/.test(pw),
  },
  {
    id: 'symbol',
    label: 'At least one symbol (!@#$%^&* etc.)',
    test: (pw) => /[^A-Za-z0-9]/.test(pw),
  },
];

/** Evaluate each rule for live UI feedback. */
export function getPasswordRuleChecks(password) {
  return PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(password),
  }));
}

export function passwordMeetsPolicy(password) {
  return getPasswordRuleChecks(password).every((r) => r.met);
}

/** First failing rule label, for form-level error messages. */
export function passwordPolicyError(password) {
  const failing = getPasswordRuleChecks(password).find((r) => !r.met);
  if (!failing) return '';
  return `Password requirements: ${failing.label.charAt(0).toLowerCase()}${failing.label.slice(1)}.`;
}
